import * as React from 'react';
import DatePicker, {
    CalendarContainer
  } from 'react-datepicker';
import * as moment from 'moment'
import './styles.scss';
import Icon from '../../icons';

import 'react-datepicker/dist/react-datepicker.css';
import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from '../../common/constants';
import { COMMENT_REQUIRED_ERROR } from '../../containers/WorkkardDetail/constants';
import { GetGenericDate, GetGenericDateFormat } from '../../common/util';
import { isMobile } from '../../common/util';

const defaultPlaceholder = 'Select Date';

class DateCalendarIcon extends React.Component {
    render() {
        return (
            <div className="datePicker" >
                <input
                    onBlur={this.props.onBlur}
                    onChange={this.props.onChange}
                    onClick={this.props.onClick}
                    onFocus={this.props.onFocus}
                    onKeyDown={this.props.onKeyDown}
                    value={this.props.value}
                    id={this.props.id}
                    type="text"
                    className={`date-picker-input ${this.props.inputClass || '' }`}
                    placeholder={this.props.displayText}
                    disabled={this.props.disabled}
                />
                <a  onClick={this.props.onClick}><Icon name="calenderIcon" className="icon"/></a>
            </div>
        );
    }
}

const TimeInput = ({ value, onChangeTimer, handleChangeTimer, onCancelClick,showButtons })=> {
    const hours = 12, mins=60;
    var hourRows = [];
    for (var i = 1; i <= hours; i++) {
        hourRows.push(<option selected={value.hours==i ? true:false} value={i}>{i < 10?'0'+i : i}</option>);
    }
    var minsRows = [];
    for (var i = 0; i < mins; i++) {
        minsRows.push(<option selected={value.mins==i ? true:false} value={i}>{i < 10?'0'+i : i}</option>);
    }
    return (
        <React.Fragment>
            <div className="timeZone react-datepicker__header ml mr mt rowSpaceBetween alignMiddle">
                <label className="mr__1">Time</label>
                <select className="mr"  onChange={(e)=>onChangeTimer(e,'hours')}>{hourRows}</select>
                <select className="mr"  onChange={(e)=>onChangeTimer(e,'mins')}>{minsRows}</select>
                <select onChange={(e)=>onChangeTimer(e,'meridiem')}><option selected={value.meridiem=='AM' ? true:false}>AM</option><option selected={value.meridiem=='PM' ? true:false}>PM</option></select>
            </div>
            {
                showButtons ?
                <div className="rowFlex rowSpaceBetween alignMiddle rowReverse">
                    <div className="alignMiddle">
                        <a className="btn link pointer" onClick={(e)=>onCancelClick(e)}>Cancel</a>
                        <a className="btn link main pointer" onClick={()=>handleChangeTimer()}>Done</a>
                    </div>
                </div>
            :
            null
            }
        </React.Fragment>
    )
 }

class ExzeoDatePicker extends React.Component {
    constructor(props) {
        super(props);
        // this.currdateObject = moment(this.props.selectedDate)
        this.state = {
            currentDate: this.props.placeholderText ? null : this.props.selectedDate ? moment(this.props.selectedDate) : null,
            initialDate: null,
            initialTime:"",
            tempDate: moment(this.props.selectedDate),
            comment:"",
            timeValue:{hours:"",mins:"",meridiem:""}
        }
        this.onChange=this.onChange.bind(this);
        this.handleConfirmClick=this.handleConfirmClick.bind(this);
        this.handleCommentChange=this.handleCommentChange.bind(this);   
        this.myContainer = this.myContainer.bind(this);
        this.onCancelClick=this.onCancelClick.bind(this);
        this.calendarRef = React.createRef();
        this.onChangeRaw = this.onChangeRaw.bind(this);
        this.onChangeTimer = this.onChangeTimer.bind(this);
        this.handleChangeTimer = this.handleChangeTimer.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        let time,hrs,mins,meri;
        if (props.selectedDate && !moment(props.selectedDate).isSame(state.initialDate)) {
            if(props.showTimePicker){
                time = props.selectedDate ? moment(props.selectedDate).format(props.dateFormat).split(",")[1] : moment().format(props.dateFormat).split(",")[1];
                time = time.split(":");
                hrs=time[0]; mins=time[1].split(" ")[0]; meri = time[1].split(" ")[1];
            }
            return {
                currentDate: moment(props.selectedDate),
                initialDate: moment(props.selectedDate),
                tempDate: moment(props.selectedDate),
                timeValue:Object.assign({},{hours:hrs,mins:mins,meridiem:meri}),
                initialTime:Object.assign({},{hours:hrs,mins:mins,meridiem:meri})                
            }
        }else if(props.showTimePicker && (props.selectedDate == null || props.selectedDate=="") && state.currentDate==null ){
            time = props.hasOwnProperty('showSysTime') && !props.showSysTime ? moment().set("hour", "23").set("minute", "59").set("second", "00").format(props.dateFormat).split(",")[1]  : moment().format(props.dateFormat).split(",")[1];
            time = time.split(":");
            hrs=time[0]; mins=time[1].split(" ")[0]; meri = time[1].split(" ")[1];
            return {
            currentDate: null,
            initialDate: null,   
            timeValue:Object.assign({},{hours:hrs,mins:mins,meridiem:meri}),
            initialTime:Object.assign({},{hours:hrs,mins:mins,meridiem:meri}) 
            }
        } else if(props.selectedDate == ""){
            return {
                currentDate: null,
                initialDate: null,
            }
        }
        return null;
    }

    onChangeTimer(selectedObj,type){
        let newValue;
        switch(type){
            case "meridiem":{
                const newMeridiem= this.state.timeValue.meridiem=="AM" ? "PM":"AM";
                newValue = Object.assign({},this.state.timeValue,{[type]:newMeridiem})
                break;
            }
            case "hours":{
                newValue = Object.assign({},this.state.timeValue,{[type]:selectedObj.target.value}) 
                break;
            }
            case "mins":{
                newValue = Object.assign({},this.state.timeValue,{[type]:selectedObj.target.value}) 
                break;
            }
            default:
                break;
        }
        this.setState({
            timeValue:newValue
        })
    }

    handleChangeTimer(){
        const date = this.state.tempDate.isValid() ? moment(this.state.tempDate).format(DEFAULT_DATE_FORMAT) : moment().format(DEFAULT_DATE_FORMAT) ;
        const dateTime = moment(date+", "+this.state.timeValue.hours+": "+this.state.timeValue.mins+" "+this.state.timeValue.meridiem, DEFAULT_TIME_FORMAT);
        this.props.onChange(dateTime);
        this.setState({
            initialTime:this.state.timeValue,
            currentDate:dateTime,
            tempDate:dateTime
        });
        if(!this.props.showComment){
            this.calendarRef.current.setOpen(false);
        }
    }

    myContainer ({ className, children }) {
       return (
           <div className={"datePickerContainer dateCalendar " + this.props.className}>
               <CalendarContainer className={className}>
                <div style={{ position: "relative" }}>{children}</div>
               </CalendarContainer>
               {
                   this.props.showTimePicker &&
                   <TimeInput value={this.state.timeValue} onChangeTimer={this.onChangeTimer} handleChangeTimer={this.handleChangeTimer} onCancelClick={this.onCancelClick} showButtons={this.props.showComment ? false : true}/>
               }
               {
                   this.props.showComment ?
                   <React.Fragment>
                    <div className="colFlex">
                        <div className="commentBox">
                            <textarea placeholder="Type your comments here..."  onChange={this.handleCommentChange}  value={this.state.comment} />
                            {this.state.isCommentError && <div className="errorMsg"><span className="errorSelfMsg">{COMMENT_REQUIRED_ERROR}</span></div>}
                        </div>
                        <div className="rowFlex alignRight">
                                <a  className="btn link" onClick={(e)=>this.onCancelClick(e)}>Cancel</a>
                            <a  className="btn link main" onClick={(e)=>this.handleConfirmClick(e)}>Done</a>
                        </div>
                    </div>
                   </React.Fragment>
                   :
                   null
               }
           </div>
       )
    }

    onCancelClick(e){
        e.preventDefault();
        this.setState({
            comment:"",
            timeValue:this.state.initialTime
        })
        this.calendarRef.current.setOpen(false);
    }

    onChangeRaw(event){
        if(event.target.value.length){
            this.setState({
                tempDate: moment(event.target.value, this.props.showTimeSelect ? DEFAULT_TIME_FORMAT : DEFAULT_DATE_FORMAT)
            })
        } else {
            this.setState({
                currentDate: null,
                tempDate: null
            }, () => this.props.onChange(null))
        }
    }

    handleOnBlur = (event) => {
        if (this.state.tempDate){
            this.onChange(this.state.tempDate)
        }
    }

    onChange(dateObj) {
        dateObj=moment(dateObj);
        if (dateObj && dateObj.isValid() && (!moment(this.state.currentDate).isSame(dateObj) 
        || (dateObj && dateObj._i !== undefined && moment(dateObj._i).isValid() 
        && this.state.currentDate._i !== undefined && !moment(this.state.currentDate._i).isSame(dateObj._i)))) {
        // this.currdateObject = dateObj
        let time, hrs, mins, meri;
        // if ((this.props.selectedDate == null || this.props.selectedDate == "") && this.props.showTimePicker) {
        if (this.props.showTimePicker) {
               hrs = this.state.timeValue.hours; mins = this.state.timeValue.mins; meri = this.state.timeValue.meridiem; 
            const date = moment(dateObj).format(DEFAULT_DATE_FORMAT);
            // var dateTime = moment(date + ", " + hrs + ": " + mins + " " + meri);
            var dateTime = moment(date + ", " + hrs + ": " + mins + " " + meri, DEFAULT_TIME_FORMAT);
        }
        this.setState({
            // currentDate: (this.props.selectedDate == null || this.props.selectedDate == "") && this.props.showTimePicker ? dateTime : dateObj,
            // tempDate: (this.props.selectedDate == null || this.props.selectedDate == "") && this.props.showTimePicker ? dateTime : dateObj,
            // timeValue: (this.props.selectedDate == null || this.props.selectedDate == "") && this.props.showTimePicker ? Object.assign({}, { hours: hrs, mins: mins, meridiem: meri }) : this.state.timeValue
            currentDate:   this.props.showTimePicker ? dateTime : dateObj,
            tempDate:   this.props.showTimePicker ? dateTime : dateObj,
            timeValue:   this.props.showTimePicker ? Object.assign({}, { hours: hrs, mins: mins, meridiem: meri }) : this.state.timeValue
        }, () => {
            if (!this.props.showTimeInput)
                this.props.onChange(  this.props.showTimePicker ? dateTime : dateObj);
        })
    };
    }

    onFocus=()=>{
        if(this.props.onFocus){
            let data={
                target:{
                    name:this.props.id
                }
            }
            this.props.onFocus(data);
        }
    }

    handleConfirmClick(e) {
        e.preventDefault();
        this.handleChangeTimer();
        if (this.state.comment.length > 0) {
            this.setState({
                isCommentError: false,
                comment:"",
                timeValue:this.state.initialTime
            })
            this.props.onConfirmClick(this.state.comment);
            this.calendarRef.current.setOpen(false);
        } else {
            this.setState({
                isCommentError: true,
            })
        }
    }

    handleCommentChange(e) {
        this.setState({
            comment: e.target.value,
        })
    }

    render() {
        return (
            <DatePicker
                {...this.props}
                ref={this.calendarRef}
                // fixedHeight  
                minDate={GetGenericDate(this.props.minDate)}
                maxDate={GetGenericDate(this.props.maxDate)}
                className={this.props.className || ""}
                selected={GetGenericDate(this.state.currentDate)}
                dateFormat={(GetGenericDateFormat(this.props.dateFormat) || DEFAULT_DATE_FORMAT).toLowerCase().replace('mm','MM')}
                timeFormat="HH:mm"
                openToDate={GetGenericDate(this.props.openToDate)}
                onChange={this.onChange}
                onFocus={this.onFocus}
                //onChangeRaw={(e)=>this.onChangeRaw(e)}
                onBlur={this.handleOnBlur}
                placeholderText={this.props.placeholderText || defaultPlaceholder}
                showTimeSelect={this.props.showTimeSelect || false}
                timeIntervals={this.props.timeIntervals || 5}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                shouldCloseOnSelect = {this.props.shouldCloseOnSelect}
                calendarContainer={this.props.myContainer ? this.myContainer :null}
                popperClassName={this.props.popperClassName || ""}
                calendarClassName={this.props.calendarClassName || ""}
                withPortal = {isMobile()}
                customInput={
                    this.props.customInput || 
                    <DateCalendarIcon
                        iconClass={this.props.iconClass}
                        displayText={
                            (this.state.currentDate && moment(this.state.currentDate).isValid())
                                ?
                                (moment(this.state.currentDate).format(((this.props.showTimeSelect || this.props.showTimeInput) ? DEFAULT_TIME_FORMAT : DEFAULT_DATE_FORMAT)))
                                :
                                (this.props.placeholderText || defaultPlaceholder)
                        }
                        inputClass={this.props.inputClass}
                    />
                }
            />
        );
    }
}
export default ExzeoDatePicker;
